module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/rectangle_play-fc98bcfef85fb24302e8a6c09dec50ab.png";